module.exports = __webpack_public_path__ + "static/img/weather_017.c4046143.svg";